import { Component, ElementRef, OnDestroy } from "@angular/core"
import { Subscription } from "rxjs"
import { UserService } from "../../../services/user.service"
import { WindowSizeService } from "../../../services/window-size.service"
import { CardComponent } from "../card.component"

@Component({
    selector: "app-ymal-card",
    templateUrl: "./ymal-card.component.html",
    styleUrls: ["./ymal-card.component.less"],
})
export class YmalCardComponent extends CardComponent implements OnDestroy {
    public ymalClass: number = 0
    public subs: Subscription[] = []

    constructor(
        public userService: UserService,
        private element: ElementRef,
        private windowSize: WindowSizeService
    ) {
        super(userService)
    }

    public ngOnInit() {
        setTimeout(() => {
            this.ymalClass = this.element.nativeElement.firstChild.clientWidth
        })

        this.subs.push(
            this.windowSize.resize.subscribe(
                () => (this.ymalClass = this.element.nativeElement.firstChild.clientWidth)
            )
        )
    }

    public ngOnDestroy() {
        this.subs.forEach((sub) => sub.unsubscribe())
    }

    public isCardLarge() {
        return this.ymalClass >= 376
    }
}
